import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Input, Button } from 'antd'

@inject((store: any) => {
    const { popupStore } = store

    return {
        popupStore
    }
})
@observer
export default class InsuranceCaseCoversPopup extends Component<any, any> {
    state: any = {
        userInfo: {},
        errors: {}
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const {
            popupStore: { popupType, info }
        } = this.props
        const cases = {}
        if (info.covers && info.covers.length > 0)
            info.covers.forEach((cover, index) => {
                const right_name = cover.right_name ? cover.right_name : 'כיסוי כללי לפוליסה'
                if (!cases[right_name]) cases[right_name] = []
                cases[right_name].push(cover)
            })
        const covers = Object.keys(cases).map((key, index) => (
            <div key={index} style={{ backgroundColor: '#f0f2f5', marginBottom: '0.2rem', padding: '0.5rem 0.6rem' }}>
                <strong>{key}</strong>
                <div>
                    <ul style={{ margin: 0 }}>
                        {cases[key].map(({ value, parameter_name, parameter_id }, index) => (
                            <li key={index}>
                                {parameter_name} : {value}{' '}
                                {!parameter_id ? <strong style={{ color: 'red' }}>(פרמטר לא נמצא)</strong> : ''}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        ))
        return (
            <Modal
                title={`כיסויים עבור ${info.policy_name}`}
                visible={popupType === 'insuranceCaseCovers'}
                onCancel={this.closePopup}
                cancelText="סגור"
            >
                <div>{covers}</div>
            </Modal>
        )
    }
}
